enum CampaignNotificationStyle {
  Success = "success",
  Warning = "warning",
  Error = "error",
}

export default CampaignNotificationStyle;